import React from 'react';
import cn from 'classnames';

import styles from './BackgroundGradient.module.css';

const BackgroundGradient = ({ className, bgColor, nucleusGradient, staticGradient, ...props }) => (
  <div
    className={cn(
      className,
      styles.backgroundGradient,
      bgColor,
      {
        [`${styles.backgroundNucleusGradient}`]: nucleusGradient,
        [`${styles.backgroundSaticGradient}`] : staticGradient
      }
    )}
    {...props}
  />
);

BackgroundGradient.defaultProps = {
  bgColor: 'bg-white',
  nucleusGradient: false,
  staticGradient: false
};

export default BackgroundGradient;
